var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [
        _vm._v(_vm._s(_vm.$t("components.sales.change-friendly-id.title"))),
      ]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$t(
                        "components.sales.change-friendly-id.number"
                      ),
                    },
                    model: {
                      value: _vm.computedFriendlyId,
                      callback: function ($$v) {
                        _vm.computedFriendlyId = $$v
                      },
                      expression: "computedFriendlyId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      label: _vm.$t(
                        "components.sales.change-friendly-id.sequence-number"
                      ),
                      decimals: 0,
                    },
                    model: {
                      value: _vm.friendlyId,
                      callback: function ($$v) {
                        _vm.friendlyId = $$v
                      },
                      expression: "friendlyId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.close")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }